import React, { useEffect, useReducer, useState } from 'react'
import { useRef } from 'react';
import VideoPlayerReducer from './VideoPlayerReducer';
const Context = React.createContext({})


export const AppContext = ({ children, initialState }) => {
    /* NavBar status interface */
    const [navigation, setNavigation] = useState(true);
    /* Data from API State */
    const [anime, setAnime] = useState({});
    const [capitules, setCapitules] = useState({});
    const [capitule, setCapitule] = useState({});
    /* Player Info state  */
    const options = {
        url: null,
        pip: false,
        playing: false,
        controls: false,
        light: false,
        volume: 0.8,
        muted: false,
        played: 0,
        loaded: 0,
        duration: 0,
        playbackRate: 1.0,
        loop: false,
        seeking: false,
        navigate: false
    }
    const playerRef = useRef(null);
    const [state, dispatch] = useReducer(VideoPlayerReducer, options);
    /* Player Handlers for redux  */
    const handlePlayPause = () => { dispatch({ type: 'PLAY_PAUSE' }) }
    const HandlePlay = () => { dispatch({ type: 'PLAY' }) }
    const HandlePause = () => { dispatch({ type: 'PAUSE' }) }
    const handleVolumeChange = (e) => {
        dispatch({ type: 'VOLUME', payload: e.target.value })
    }
    const handleDuration = (duration) => {
        console.log('onDuration', duration)
        //this.setState({ duration })
        dispatch({ type: 'DURATION', payload: duration })
    }
    /* Busqueda en video */
    const handleSeekMouseDown = () => { dispatch({ type: 'SEEK', payload: true }) };
    const handleSeekChange = (e) => {
        dispatch({ type: 'SEEK_CHANGE', payload: parseFloat(e.target.value) })
    };
    const handleFordward10 = (e) => {
        dispatch({ type: 'FORWARD_10', payload: playerRef })
    }
    const handleAdvance10 = (e) => {
        dispatch({ type: 'ADVANCE_10', payload: playerRef })
    }
    const handleSeekMouseUp = (e) => {
        dispatch({ type: 'SEEK', payload: false })
        dispatch({
            type: 'SEEK_NEW', payload: {
                ref: playerRef, value: e.target.value
            }
        })
    };
    const handleProgress = state => {
        // We only want to update time slider if we are not currently seeking
        dispatch({ type: 'ON_PROGRESS', payload: state })
    }
    /* UseInitialState data on app  */
    useEffect(() => {
        const initialData = initialState[0] || {};
        setAnime(initialData);
    }, [initialState])

    return (
        <Context.Provider value={{ state, initialState, anime, setAnime, capitules, setCapitules, navigation, setNavigation, handlePlayPause, HandlePlay, HandlePause, capitule, setCapitule, handleVolumeChange, handleDuration, handleSeekMouseDown, handleSeekChange, handleSeekMouseUp, handleProgress, playerRef, handleFordward10, handleAdvance10 }}>
            {children}</Context.Provider>
    )
}

export default Context